// States
export const FAILED_STATE = "failed_state"
export const COMPLETED_STATE = "completed_state"
export const PENDING_STATE = "pending_state"
export const FOUND_STATE = "found_state"
export const DELETED_STATE = "deleted_state"
export const NOT_CHOOSEN_STATE = "not_choosen_state"
export const CREATE_STATE = "create_state"
export const CREATE_FAILED_STATE = "create_failed_state"
export const CREATE_SUCCESS_STATE = "creates_success_state"
export const UPDATE_FAILED_STATE = "update_failed_state"
export const UPDATE_SUCCESS_STATE = "update_success_state"
export const SEARCH_FAILED_STATE = "search_failed_state"
export const UPDATE_STATE = "update_state"
export const UNAUTHORIZED_STATE = "unauthorized_state"
export const AUTHORIZED_STATE = "authorized_state"
export const WAITING_STATE = "waiting_state"
export const UNAVAILABLE_STATE = "unavailable_state"
export const PLATE_REGISTERED_SUCCESS = "plate_registered_success"

// Field IDs
export const NAME_FIELD = "name_field"
export const ID_FIELD = "id_field"
export const MAIL_FIELD = "mail_field"
export const NUMBER_FIELD = "number_field"
export const STRING_FIELD = "string_field"
export const PLATE_FIELD = "plate_field"

// AUTHORIZATION KEYS
export const AUTH_MAIL = "mail"
export const AUTH_APIKEY = "apikey"
export const AUTH_REFRESH_TOKEN = "refreshToken"
export const AUTH_EXPIRES_IN = "expiresIn"

